import { Md5 } from 'ts-md5';
import { HttpService } from './../services/http.service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { NzModalService, NzMessageService } from 'ng-zorro-antd';
import { StorageService } from './../services/storage.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less']
})
export class SearchComponent implements OnInit {

  searchContent = '';
  searchType = 0;       //显示类型：0=全部；1=标签；2=问题；3=文章
  searchList: any = []; //搜索结果列表

  page = 1;                   //列表显示第几页
  page_num = 10;              //每页显示的数量
  total: any = [];            //总共几页
  page_prev = 1;
  page_next = 5;

  constructor(
    private local: StorageService,
    private modalService: NzModalService,
    private router: Router,
    public http: HttpService,
    private msg: NzMessageService,
    private route: ActivatedRoute,
  ) {
     // override the route reuse strategy 复用路由
     this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    route.queryParams.subscribe((data) => {
      this.searchContent = data.content;
    });
  }

  ngOnInit() {
    //获取查询结果列表
    this.getSearchList(0);
  }

  /**
   * 获取搜索结果列表user/dynamic/search
   */
  getSearchList(value) {
    if(value!=this.searchType){
      this.page = 1;
    }
    this.route.queryParams.subscribe((data) => {
      if(this.searchContent!=data.content) {
        let navigationExtras: NavigationExtras = {
          queryParams: { 'content': this.searchContent },
        }
        this.router.navigate(['/search'], navigationExtras);
        this.searchContent = '';
      }
    });
    this.searchType = value;
    let signature = Md5.hashStr('CYYbQyB7FdIS8xuBEwVwbBDMQKOZPMXK|' + new Date().getTime().toString().substr(0, 10) + '|search');
    var api = 'user/dynamic/search';
    var body = {
      'timestamp': new Date().getTime().toString().substr(0, 10),
      'signature': signature,
      'keyword': this.searchContent,
      'type': value,
      'page': this.page,
      'page_num': this.page_num,
    }
    // console.log("body", body);
    this.http.doPost(api, body, (result) => {
      // console.log(result);
      this.searchList = [];
      this.total = [];
      if (result.code == "200") {
        if (result.data != null && result.data.length > 0) {
          this.searchList = result.data;
          for (let i = 0; i < result.page_info.total; i++) {
            this.total.push({ num: i + 1, checked: this.page == i + 1 });
          }
        }
      // } else {
      //   this.modalService.error({
      //     nzTitle: "系统提示",
      //     nzContent: result.message,
      //     nzOkText: "关闭",
      //     nzOnOk: () => { },
      //   })
      }
    })
  }

   /**跳转到页面 */
   getPageData(num) {
    this.page = num;
    this.updatepage();
    // console.log(this.page);
    this.getSearchList(this.searchType);
  }
  /**到上一页 */
  doPrevious() {
    this.page--;
    this.updatepage();
    // console.log(this.page);
    this.getSearchList(this.searchType);
  }
  /**到下一页 */
  doNext() {
    this.page++;
    this.updatepage();
    // console.log(this.page);
    this.getSearchList(this.searchType);
  }
  /**更新页面选择器 */
  updatepage() {
    window.scrollTo(0, 0)
    for (let i = 0; i < this.total.length; i++) {
      if (this.total[i].num == this.page) {
        this.total[i].checked = true;
      } else {
        this.total[i].checked = false;
      }
    }
    if (this.page == 1) {
      this.page_prev = this.page;
      this.page_next = this.page + 4;
    } else if (this.page == 2) {
      this.page_prev = this.page - 1;
      this.page_next = this.page + 3;
    } else if (this.page == this.total.length - 1) {
      this.page_prev = this.page - 3;
      this.page_next = this.page + 1;
    } else if (this.page == this.total.length) {
      this.page_prev = this.page - 4;
      this.page_next = this.page;
    } else {
      this.page_prev = this.page - 2;
      this.page_next = this.page + 2;
    }
  }
   /**向前5页 */
   prev(num) {
    if (num - 5 < 1) {
      this.page = 1;
    } else {
      this.page = num - 5;
    }
    this.updatepage();
    this.getSearchList(this.searchType);
  }
  /**向后5页 */
  next(num) {
    if (num + 5 > this.total.length) {
      this.page = this.total.length;
    } else {
      this.page = num + 5;
    }
    this.updatepage();
    this.getSearchList(this.searchType);
  }

  goDetail(serach) {
    // let navigationExtras: NavigationExtras = {
    //   queryParams: { 'id': serach.id, },
    // }
    var url = '';
    switch (serach.type) {
      case 1:
        url = '/labels-detail/'
        break;
      case 2:
        url = '/q/'
        break;
      case 3:
        url = '/a/'
        break;
      default:
        break;
    }
    this.router.navigate([url+serach.id]);
  }
}
